import { css } from 'styled-components';
export var pagesWrapper = /*#__PURE__*/css(["width:100%;overflow:hidden;"]);
export var pages = /*#__PURE__*/css(["display:flex;overflow:hidden;flex-grow:1;transform:translate3d(var(--translateX),0,0);"]);